export const menuDefine = {
  DASHBOARD: 'dashboard',
  TOPOLOGYMAP: 'topologymap',
  PERF_OPER: 'perf-oper',
  CONFIG: 'config',
  CHART: 'chart',
  LOG: 'log',
  LOG_ANALYSIS: 'log-analysis',
  EVENT: 'event',
  PREDICTEVENT: 'event-predict',
  WORK: 'work',
  REPORT: 'report',
  APM: 'apm',
  SETTINGS: 'settings',
};

export const menuDepthDefine = {
  [menuDefine.DASHBOARD]: 2,
  [menuDefine.TOPOLOGYMAP]: 2,
  [menuDefine.PERF_OPER]: 3,
  [menuDefine.CHART]: 1,
  [menuDefine.LOG]: 3,
  [menuDefine.LOG_ANALYSIS]: 3,
  [menuDefine.EVENT]: 3,
  [menuDefine.WORK]: 1,
  [menuDefine.REPORT]: 3,
  [menuDefine.APM]: 3,
};

export const settingsMenu = {
  id: menuDefine.SETTINGS,
  name: '설정',
  icon: 'fa fa-cog',
  detph: 1,
  orderbyIndex: 0,
};

export default menuDefine;



// WEBPACK FOOTER //
// ./src/constants/menu.js